import Vue from 'vue'
import store from '@/store'

let menu = new Vue ({
  data: {
    elementos: [
      {
        seccion: 1,
        titulo: "Inicio",
        icono: "mdi-home",
        ruta: "/panel/#",
        componente: () => import(`@/pages/Inicio.vue`),
      },
      {
        seccion: 1,
        titulo: "Vista global",
        icono: "mdi-eye",
        ruta: "/panel/vistaGlobal",
        parametroConfiguracionRequerido: "modconrem",
        atributoRolOperadorNecesario: "accvisglo",
        componente: () => import(`@/pages/VistaGlobal.vue`),
      },
      {
        seccion: 1,
        titulo: "Sinóptico de aparcamiento",
        icono: "mdi-monitor",
        ruta: "/panel/sinopticoAparcamiento",
        parametroConfiguracionRequerido: "modconrem",
        atributoRolOperadorNecesario: "accsinapa",
        componente: () => import(`@/pages/SinopticoAparcamiento.vue`),
      },
      {
        seccion: 1,
        titulo: "Asistencia remota",
        icono: "mdi-face-agent",
        ruta: "/panel/asistenciaRemota",
        parametroConfiguracionRequerido: "modint",
        atributoRolOperadorNecesario: "regint",
        componente: () => import(`@/pages/AsistenciaRemota.vue`),
      },
      {
        seccion: 1,
        titulo: "Registro de interfonía",
        icono: "mdi-phone-log",
        ruta: "/panel/registroInterfonia",
        notificaciones: 0,
        parametroConfiguracionRequerido: "modint",
        atributoRolOperadorNecesario: "regint",
        componente: () => import(`@/pages/RegistroInterfonia.vue`),
      },
      {
        seccion: 2,
        titulo: "Pases",
        icono: "mdi-badge-account-horizontal",
        ruta: "/panel/pases",
        componente: () => import(`@/pages/GestionPases.vue`),
      },
      {
        seccion: 2,
        titulo: "Reservas",
        icono: "mdi-calendar-check",
        ruta: "/panel/reservas",
        parametroConfiguracionRequerido: "modres",
        atributoRolOperadorNecesario: "visres",
        componente: () => import(`@/pages/GestionReservas.vue`),
      },
      {
        seccion: 2,
        titulo: "Cesiones de plazas",
        icono: "mdi-sync",
        ruta: "/panel/cesionesPlazas",
        parametroConfiguracionRequerido: "modres",
        atributoRolOperadorNecesario: "visres",
        componente: () => import(`@/pages/GestionCesionesPlazas.vue`),
      },
      {
        seccion: 2,
        titulo: "Visitas",
        icono: "mdi-badge-account-outline",
        ruta: "/panel/visitas",
        parametroConfiguracionRequerido: "modvisempinq",
        atributoRolOperadorNecesario: "visvisempinq",
        componente: () => import(`@/pages/GestionVisitas.vue`),
      },
      {
        seccion: 2,
        titulo: "Validaciones de tickets",
        icono: "mdi-star-check",
        ruta: "/panel/validacionTickets",
        parametroConfiguracionRequerido: "modvaltic",
        atributoRolOperadorNecesario: "valtic",
        componente: () => import(`@/pages/ValidacionTickets.vue`),
      },
      {
        seccion: 2,
        titulo: "Registro de eventos",
        icono: "mdi-arrow-left-right-bold",
        ruta: "/panel/registroEventos",
        componente: () => import(`@/pages/RegistroEventos.vue`),
      },
      {
        seccion: 2,
        titulo: "Informes",
        icono: "mdi-file-outline",
        ruta: "/panel/Informes",
        parametroConfiguracionRequerido: "modinf",
        atributoRolOperadorNecesario: "gesinf",
        componente: () => import(`@/pages/Informes.vue`),
      },
      {
        seccion: 3,
        titulo: "Distribución de plazas",
        icono: "mdi-plus-minus-variant",
        ruta: "/panel/distribucionPlazas",
        parametroConfiguracionRequerido: "modempinq",
        atributoRolOperadorNecesario: "gesdispla",
        componente: () => import(`@/pages/GestionDistribucionPlazas.vue`),
      },
      {
        seccion: 4,
        titulo: "Registro de auditoría",
        icono: "mdi-clipboard-search-outline",
        ruta: "/panel/registroAuditoria",
        atributoRolOperadorNecesario: "regaud",
        componente: () => import(`@/pages/RegistroAuditoria.vue`),
      },
      {
        seccion: 4,
        titulo: "Configurar",
        icono: "mdi-cog-outline",
        menu: "configurar",
      },
          {
            seccion: 12,
            titulo: "Empresas inquilinas",
            icono: "mdi-vector-square",
            ruta: "/panel/empresasInquilinas",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modempinq",
            atributoRolOperadorNecesario: "gesempinq",
            componente: () => import(`@/pages/GestionEmpresasInquilinas.vue`),
          },
          {
            seccion: 12,
            titulo: "Tipos de pases",
            icono: "mdi-format-list-text",
            ruta: "/panel/tiposPases",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gestippas",
            componente: () => import(`@/pages/GestionTiposPases.vue`),
          },
          {
            seccion: 12,
            titulo: "Tarifas",
            icono: "mdi-progress-clock",
            ruta: "/panel/gestionTarifas",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modtar",
            atributoRolOperadorNecesario: "gestar",
            componente: () => import(`@/pages/GestionTarifas.vue`),
          },
          {
            seccion: 12,
            titulo: "Listas de precios",
            icono: "mdi-timetable",
            ruta: "/panel/gestionListasPrecios",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modtar",
            atributoRolOperadorNecesario: "geslispre",
            componente: () => import(`@/pages/GestionListasPrecios.vue`),
          },
          {
            seccion: 12,
            titulo: "Festivos",
            icono: "mdi-calendar-star",
            ruta: "/panel/gestionFestivos",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modtar",
            atributoRolOperadorNecesario: "gesfes",
            componente: () => import(`@/pages/GestionFestivos.vue`),
          },
          {
            seccion: 12,
            titulo: "Horarios",
            icono: "mdi-folder-clock-outline",
            ruta: "/panel/gestionHorarios",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modtar",
            atributoRolOperadorNecesario: "geshor",
            componente: () => import(`@/pages/GestionHorarios.vue`),
          },
          {
            seccion: 13,
            titulo: "Interfonías",
            icono: "mdi-phone-in-talk",
            ruta: "/panel/gestionInterfonias",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modint",
            atributoRolOperadorNecesario: "gesdisint",
            componente: () => import(`@/pages/GestionInterfonias.vue`),
          },
          {
            seccion: 13,
            titulo: "Cámaras",
            icono: "mdi-video-outline",
            ruta: "/panel/gestionCamaras",
            cuelgaDeMenu: "configurar",
            parametroConfiguracionRequerido: "modcam",
            atributoRolOperadorNecesario: "gescam",
            componente: () => import(`@/pages/GestionCamaras.vue`),
          },
          {
            seccion: 14,
            titulo: "Aparatos",
            icono: "mdi-boom-gate",
            ruta: "/panel/gestionAparatos",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "visconapa",
            componente: () => import(`@/pages/GestionAparatos.vue`),
          },
          {
            seccion: 14,
            titulo: "Zonas de aparcamientos",
            icono: "mdi-select-marker",
            ruta: "/panel/gestionZonas",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "visconzon",
            componente: () => import(`@/pages/GestionZonas.vue`),
          },
          {
            seccion: 14,
            titulo: "Aparcamientos",
            icono: "mdi-file-powerpoint-box",
            ruta: "/panel/gestionInstalaciones",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "visconins",
            componente: () => import(`@/pages/GestionInstalaciones.vue`),
          },
          {
            seccion: 15,
            titulo: "Operadores",
            icono: "mdi-account-key",
            ruta: "/panel/gestionOperadores",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesope",
            componente: () => import(`@/pages/GestionOperadores.vue`),
          },
          {
            seccion: 15,
            titulo: "Roles de operador",
            icono: "mdi-account-details",
            ruta: "/panel/gestionRolesOperador",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesrolope",
            componente: () => import(`@/pages/GestionRolesOperador.vue`),
          },
          {
            seccion: 16,
            titulo: "Parámetros de configuración",
            icono: "mdi-application-cog",
            ruta: "/panel/parametrosConfiguracion",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesparcon",
            componente: () => import(`@/pages/GestionParametrosConfiguracion.vue`),
          },
      {
        seccion: 9,
        titulo: "Mantenimiento",
        icono: "mdi-wrench-outline",
        menu: "mantenimiento",
      },
          {
            seccion: 16,
            titulo: "Estado del sistema",
            icono: "mdi-comment-check-outline",
            ruta: "/panel/estadoSistema",
            cuelgaDeMenu: "mantenimiento",
            atributoRolOperadorNecesario: "regaud",
            componente: () => import(`@/pages/EstadoSistema.vue`),
          },
          {
            seccion: 16,
            titulo: "Consola de SQL",
            icono: "mdi-database",
            ruta: "/panel/consolaSQL",
            cuelgaDeMenu: "mantenimiento",
            atributoRolOperadorNecesario: "gesparcon",
            componente: () => import(`@/pages/ConsolaSQL.vue`),
          },
          {
            seccion: 16,
            titulo: "Importación de datos",
            icono: "mdi-database-import",
            ruta: "/panel/importacionDatos",
            cuelgaDeMenu: "mantenimiento",
            atributoRolOperadorNecesario: "gesparcon",
            componente: () => import(`@/pages/ImportacionDatos.vue`),
          },
    ]
  },
  methods: {
    obtenerElementoRuta (rutaElemento) {
      return this.elementos.find (elemento => this.rutaSinHash (elemento.ruta) == rutaElemento);
    },
    procedeNavegarAElemento (elemento) {
      let procede = true;
      procede &= (elemento.parametroConfiguracionRequerido ? this.$parametros_configuracion [elemento.parametroConfiguracionRequerido] : true);
      procede &= (elemento.atributoRolOperadorNecesario ? store.operador.atributosRol.includes (elemento.atributoRolOperadorNecesario) : true);
      return procede;
    },
    procedeMostrarElemento (elemento) {
      let procede = this.procedeNavegarAElemento (elemento);
      procede &= (elemento.visible !== undefined ? elemento.visible : true);
      return procede;
    },
    elementosQueProcedeMostrar() {
      return this.elementos.filter((elemento) => this.procedeMostrarElemento (elemento));
    },
    arbolOpcionesMenu() {
      let elementosMenu = this.elementosQueProcedeMostrar();
      let array = [];

      elementosMenu.forEach ((e1) => {
        if (!e1.cuelgaDeMenu) {
          let aux = {...e1};
          if (aux.menu) {
            aux.elementos = [];
            elementosMenu.forEach ((e2) => {
              if (e2.cuelgaDeMenu == aux.menu)
                aux.elementos.push ({...e2});
            });
            if (aux.elementos.length > 0)
              array.push (aux);
          } else {
            array.push (aux);
          }
        }
      });
      return array;
    },
    rutaSinHash (ruta) {
      if (ruta && ruta.endsWith ('#'))
        return ruta.slice (0, -1);
      else
        return ruta;
    },
    arrayRutasPanel() {
      let array = [];

      this.elementos.forEach ((elemento) => {
        if (elemento.ruta)
          array.push ({
            path: this.rutaSinHash (elemento.ruta),
            component: elemento.componente,
            meta: { elementoMenu: elemento }
          });
      });

      return [{
        path: '/panel',
        meta: {
          name: 'Vista del panel',
        },
        component: () => import(`@/views/VistaPanel.vue`),
        children: array
      }];
    },
    aplicarTraducciones() {
      this.elementos.forEach ( (elemento) => {
        elemento.titulo = this.$t (elemento.titulo);
      });
    }
  }
});

export default menu;